module.exports = "<div class=\"modal\">\n  <section>\n    <header>\n      <h4 class=\"grow\">{{title}}</h4>\n    </header>\n    <div>\n      <ng-content select=\"[message]\"></ng-content>\n    </div>\n    <footer>\n      <button (click)=\"cancel.next()\">Cancel</button>\n      <button [ngClass]=\"confirmClass\" (click)=\"confirm.next()\">{{confirmLabel}}</button>\n    </footer>\n  </section>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./~/@c4/programming/src/app/common/confirm-modal/confirm-modal.component.html
// module id = 1529
// module chunks = 2